// Local development
// export const baseUrl = "http://localhost:3002/api/";
// export const baseImageUrl = "http://localhost:3002/";

// Production (uncomment before building for server)
export const baseUrl = "https://smartstart.byteltd.com/api/";
export const baseImageUrl = "https://smartstart.byteltd.com/uploads/";
